import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IComponentOptions, IIntervalService, IPromise, IScope } from "angular";
import { SetupStep } from "../models";
import { WorkdayUserProvisioningService } from "../workday-user-provisioning-service";

const pollingIntervalMillis = 5000; // 5 sec

export class SyncSelectionInfoCtrl {
  currentStep: SetupStep;
  progressSteps = SetupStep;
  intervalValue: IPromise<unknown>;

  public static $inject = ["$scope", "WorkdayUserProvisioningService", "UIErrorHandlingService", "$interval"];
  constructor(
    private $scope: IScope,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $interval: IIntervalService
  ) {}

  $onInit(): void {
    if (this.currentStep === SetupStep.DATA_SYNC) {
      this.waitForDataSyncToBeDone();
    }
  }

  $onDestroy(): void {
    this.clearIntervalValue();
  }

  waitForDataSyncToBeDone = (): void => {
    this.workdayUserProvisioningService
      .dataAvailable()
      .then((response) => {
        if (response.available) {
          this.clearIntervalValue();
          this.$scope.$root.$broadcast("progressStepChanged");
        } else {
          if (!this.intervalValue) {
            this.intervalValue = this.$interval(this.waitForDataSyncToBeDone, pollingIntervalMillis);
          }
        }
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  };

  private clearIntervalValue(): void {
    if (this.intervalValue) {
      this.$interval.cancel(this.intervalValue);
      delete this.intervalValue;
    }
  }
}

export const SyncSelectionInfoComponent: IComponentOptions = {
  bindings: {
    currentStep: "<",
  },

  controller: SyncSelectionInfoCtrl,
  templateUrl: require("./sync-selection-info.jade"),
  controllerAs: "$ctrl",
};
